import { useTheme } from "./ThemeProvider";

/**
 * Aviso: teléfono/email ya existen en el CRM.
 * contexto "captacion": Continuar / Descartar captación
 * contexto "contacto": Continuar / No crear (evitar duplicar propietario u otro contacto)
 * labelContinuar / labelDescartar: opcionales para personalizar.
 */
export default function ModalRelacionContactoExistente({
  open,
  matches = [],
  canal = "telefono",
  onClose,
  onDescartar,
  contexto = "captacion",
  labelContinuar: labelContinuarProp,
  labelDescartar: labelDescartarProp,
  ocultarDescartar = false,
}) {
  const { theme } = useTheme();
  const c = theme.colors;
  const isDark = theme.name === "dark";
  const esContacto = contexto === "contacto";

  if (!open || !matches.length) return null;

  const tituloCanal =
    canal === "email"
      ? "Este email ya está en el CRM"
      : canal === "ambos"
        ? "Este teléfono o email ya está en el CRM"
        : "Este teléfono ya está en el CRM";

  const subtitulo = esContacto
    ? "Si ya existe, puedes usar ese registro en lugar de crear uno nuevo. Si continúas, no volveremos a avisarte por este teléfono/email en esta sesión."
    : "Si ya existe, puedes descartar esta captación o continuar. Si continúas, no volveremos a avisarte por este teléfono/email.";

  const labelContinuar = labelContinuarProp
    || (esContacto ? "Continuar de todos modos" : "Continuar con la captación");

  const labelDescartar = labelDescartarProp
    || (esContacto ? "No crear / cancelar" : "Descartar captación");

  return (
    <div
      role="dialog"
      aria-modal="true"
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 12000,
        background: "rgba(15, 23, 42, 0.55)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 16,
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          width: "100%",
          maxWidth: 440,
          borderRadius: 14,
          background: isDark ? "#0f172a" : "#fff",
          border: `1px solid ${isDark ? "#334155" : "#e2e8f0"}`,
          boxShadow: "0 20px 50px rgba(0,0,0,0.35)",
          overflow: "hidden",
          fontFamily: "inherit",
        }}
      >
        <div
          style={{
            padding: "16px 18px 12px",
            borderBottom: `1px solid ${isDark ? "#1e293b" : "#f1f5f9"}`,
            display: "flex",
            alignItems: "flex-start",
            gap: 12,
          }}
        >
          <div
            style={{
              width: 36,
              height: 36,
              borderRadius: 10,
              flexShrink: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              background: isDark ? "rgba(245, 158, 11, 0.15)" : "#fffbeb",
              color: "#d97706",
              fontSize: 18,
              fontWeight: 800,
            }}
          >
            !
          </div>
          <div style={{ minWidth: 0, flex: 1 }}>
            <div style={{ fontSize: 16, fontWeight: 750, color: c.textPrimary, lineHeight: 1.3 }}>
              {tituloCanal}
            </div>
            <div style={{ fontSize: 12, color: c.textSecondary, marginTop: 4, lineHeight: 1.4 }}>
              {subtitulo}
            </div>
          </div>
        </div>

        <div style={{ padding: "12px 18px 8px", maxHeight: 280, overflowY: "auto" }}>
          {matches.map((m) => (
            <div
              key={`${m.entity_type}-${m.id}`}
              style={{
                padding: "10px 12px",
                marginBottom: 8,
                borderRadius: 10,
                background: isDark ? "#1e293b" : "#f8fafc",
                border: `1px solid ${isDark ? "#334155" : "#e2e8f0"}`,
                fontSize: 13,
                color: c.textPrimary,
                lineHeight: 1.45,
              }}
            >
              {m.mensaje}
            </div>
          ))}
        </div>

        <div style={{ padding: "8px 18px 16px", display: "flex", flexDirection: "column", gap: 8 }}>
          <button
            type="button"
            onClick={onClose}
            style={{
              border: "none",
              borderRadius: 10,
              padding: "12px 16px",
              fontWeight: 700,
              fontSize: 14,
              cursor: "pointer",
              fontFamily: "inherit",
              background: "#16a34a",
              color: "#fff",
            }}
          >
            {labelContinuar}
          </button>
          {!ocultarDescartar && (
          <button
            type="button"
            onClick={() => (onDescartar ? onDescartar() : onClose?.())}
            style={{
              border: "none",
              borderRadius: 10,
              padding: "12px 16px",
              fontWeight: 700,
              fontSize: 14,
              cursor: "pointer",
              fontFamily: "inherit",
              background: "#dc2626",
              color: "#fff",
            }}
          >
            {labelDescartar}
          </button>
          )}
        </div>
      </div>
    </div>
  );
}
